import React from 'react';

interface IDeleteIconEditorProps {
  style?: any;
}

export const DeleteIconEditor:React.FC<IDeleteIconEditorProps> = (props: IDeleteIconEditorProps) => {
  return (
<svg width="15" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 2.25v.9a.46.46 0 0 1-.469.45H.47A.46.46 0 0 1 0 3.15v-.9c0-.249.21-.45.469-.45h4.218V.9c0-.497.42-.9.938-.9h3.75c.518 0 .938.403.938.9v.9h4.218a.46.46 0 0 1 .469.45zM1.753 16.326c.07.945.889 1.676 1.875 1.674h7.763c.986.002 1.806-.73 1.875-1.674L14.062 5.4H.938l.815 10.926z" fill="#CCC"/>
</svg>
 )
}